import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useCloneRecruitments = () => {
  return usePost({ url: ApiRoutesEnum.recruitmentsBulkClone });
};
